import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BaseComponent } from '@app/base/base.component';
import { OriginalShell } from '@app/features/original/original-feature-set';
import { ContentEditorService } from '@app/shared/services/content-editor.service';
import { FeatureService } from '@app/shared/services/feature.service';
import { PageTitleService } from '@app/shared/services/page-title.service';
import { SetFocusService } from '@app/shared/services/set-focus.service';
import { ThemeService } from '@app/shared/services/theme.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { filter } from 'rxjs/operators';

interface KYCShellConfig {
    showTranslationAssistanceLink: boolean;
    pcnOnly: boolean;
}
@Component({
    selector: 'app-kyc-shell',
    templateUrl: './kyc-shell.component.html',
    styleUrls: ['./kyc-shell.component.scss'],
})
export class KycShellComponent extends BaseComponent implements OnInit {
    constructor(
        private route: Router,
        private translateService: TranslateService,
        private activeRoute: ActivatedRoute,
        private pageTitleService: PageTitleService,
        private contentEditorService: ContentEditorService,
        private setFocus: SetFocusService,
        private features: FeatureService,
        private themeService:ThemeService
    ) {
        super();
    }

    tenantKeyTitle: string;
    shellConfig: KYCShellConfig;
    kycPageCustomLogo:string;

    ngOnInit(): void {
        this.kycPageCustomLogo = this.themeService.themeConfig && this.themeService.themeConfig['kyc-logo'];

        this.activeRoute.data.subscribe((data) => {
            this.contentEditorService.translationKeyMap.clear();
            this.contentEditorService.resourceList = data['contentEditorData'];
            this.contentEditorService.onContentEditorRouteChangeSub.emit({ changed: true, url: this.route.url });
        });

        this.shellConfig = this.features.getShell(OriginalShell.KYCShell).configuration as KYCShellConfig;

        this.onTranslationChange();
    }

    routeActivate(): void {
        scroll(0, 0);
        this.setFocus.setFocusTo('navigation');
        this.setTitleOnRouteChange();
    }

    onTranslationChange(): void {
        this.subscriptions.push(
            this.translateService.onLangChange.subscribe(async () => {
                this.pageTitleService.pageTitleHelper();
            }),
        );
    }

    async setTitleOnRouteChange(): Promise<void> {
        const routeEvent = await firstValueFrom(this.route.events.pipe(filter((e) => e instanceof NavigationEnd)));

        if (routeEvent) {
            this.pageTitleService.pageTitleHelper();
        }
    }
}
